export default __webpack_public_path__ + "static/media/gallery_05.fce7f2f0.jpg";